export const translations = {
  fr: {
    // Navbar
    navbar: {
      home: 'Accueil',
      about: 'À Propos',
      menu: 'Menu',
      gallery: 'Galerie',
      contact: 'Contact',
      reservation: 'Réservation',
      hoursTopBar: 'DE 18H À 01H00 | WEEKEND JUSQU\'À 03H',
    },
    // Home Page
    home: {
      welcome: 'Bienvenue à Jana Marrakech',
      subtitle: 'RESTAURANT MAROCAIN',
      heroDescription: 'Niché au cœur du prestigieux Complexe du Pacha à Marrakech',
      exploreMenu: 'Découvrir le Menu',
      bookTable: 'Réserver Maintenant',
      welcomeDesc1: 'Découvrez une expérience culinaire unique à Marrakech. Situé au cœur du prestigieux complexe du Pacha, Jana Marrakech propose un concept innovant qui combine gastronomie, divertissement et hospitalité marocaine.',
      welcomeDesc2: 'Notre menu au choix offre une sélection variée de plats marocains authentiques et de spécialités internationales.',
      learnMore: 'En Savoir Plus',
      specialties: 'Nos Spécialités',
      ambiance: 'Ambiance Authentique',
      service: 'Service Excellent',
      moroccanCuisine: 'Cuisine Marocaine',
      moroccanCuisineDesc: 'Une sélections variée de plats marocains préparés avec passion',
      showAmbiance: 'Show & Ambiance',
      danseusesGnawa: 'Danseuses | Gnawa',
      showAmbianceDesc: 'Spectacles live et animations pour une soirée inoubliable à Marrakech',
      janaExperience: 'L\'Expérience JANA',
      janaExperienceDesc: 'Profitez d\'une soirée complète avec cuisine marocaine, boissons et spectacles inclus.',
      galleryPhotos: 'Galerie Photos',
      galleryPhotosDesc: 'Découvrez l\'ambiance unique de Jana Marrakech',
      viewMorePhotos: 'Voir Plus de Photos',
      hours: 'Horaires',
      hoursOpen: 'De 18H00 à 01H00',
      hoursWeekend: 'Weekend Jusqu\'à 03H00',
      address: 'Adresse',
      addressText: 'Zone Touristique De L\nBd Mohamed VI, Marrakech 40000',
      reservation: 'Réservation',
      reserveNow: 'Réservez Maintenant',
      reserveTable: 'Reservez votre table dés maintenant',
      reserveTableDesc: 'Vivez une expérience culinaire unique dans le prestigieux complexe du Pacha à Marrakech',
    },
    // About Page
    about: {
      title: 'À Propos de Jana Marrakech',
      description: 'Découvrez notre histoire et notre passion pour la cuisine marocaine',
      ourStory: 'Notre Histoire',
      ourMission: 'Notre Mission',
      ourValues: 'Nos Valeurs',
      ourValuesDesc: 'Les principes qui guident notre engagement envers l\'excellence',
      uniqueExperience: 'Une expérience culinaire unique à Marrakech',
      storyPart1: 'Jana Marrakech est né d\'une vision audacieuse : créer un lieu où la gastronomie marocaine rencontre l\'hospitalité légendaire de notre ville.',
      storyPart2: 'Situé dans le prestigieux Complexe du Pacha, au cœur de la zone touristique de l\'Agdal, notre restaurant offre une expérience unique qui combine menu raffiné, spectacles live dans un cadre élégant et chaleureux.',
      storyPart3: 'Chaque soir, nous accueillons nos invités dans une ambiance festive et conviviale, où les saveurs authentiques du Maroc se mêlent aux influences internationales pour créer une expérience culinaire inoubliable.',
      concept: 'Le Concept JANA',
      conceptDesc: 'Une expérience unique à Marrakech, nichée au cœur du prestigieux Complexe du Pacha.',
      moroccanCuisine: 'Cuisine marocaine',
      moroccanCuisineDesc: 'Notre carte est idéale pour découvrir ou redécouvrir les saveurs traditionnelles marocaines. Découvrez une sélection de plats authentiques, préparés avec des ingrédients frais et de qualité. Nos chefs talentueux proposent un menu raffiné et savoureux, pour une expérience hors du commun.',
      showAmbiance: 'Show & Ambiance',
      showAmbianceDesc: 'Vivez une soirée animée avec nos spectacles live et animations. Musique traditionnelle marocaine, danse orientale et ambiance festive sont au rendez-vous pour faire de votre soirée un moment inoubliable.',
      exceptionalSetting: 'Cadre Exceptionnel',
      exceptionalSettingDesc: 'Notre restaurant combine l\'élégance moderne avec les touches traditionnelles marocaines. Un décor soigné et une ambiance chaleureuse créent le cadre parfait pour vos soirées entre amis ou en famille.',
      excellence: 'Excellence',
      excellenceDesc: 'Nous nous engageons à offrir une qualité exceptionnelle dans chaque aspect de votre expérience.',
      passion: 'Passion',
      passionDesc: 'Notre passion pour la gastronomie marocaine se reflète dans chaque plat que nous servons.',
      hospitality: 'Hospitalité',
      hospitalityDesc: 'L\'hospitalité marocaine authentique est au cœur de notre service.',
      innovation: 'Innovation',
      innovationDesc: 'Restaurant marocain et animations dans un écrin unique à Marrakech.',
      dedicatedTeam: 'Une Équipe Passionnée',
      dedicatedTeamDesc: 'Notre équipe de chefs talentueux et de professionnels dévoués travaille chaque jour pour vous offrir une expérience exceptionnelle. De la cuisine à la salle, en passant par le bar et les spectacles, chaque membre de notre équipe contribue à créer la magie de Jana Marrakech.',
      tradition: 'Nous sommes fiers de perpétuer la tradition d\'hospitalité marocaine tout en innovant pour vous surprendre à chaque visite.',
      joinUs: 'Rejoignez-nous pour une soirée inoubliable',
      joinUsDesc: 'Découvrez pourquoi Jana Marrakech est devenu la destination incontournable pour une expérience unique',
    },
    // Menu Page
    menu: {
      title: 'Notre Menu',
      subtitle: 'Saveurs Marocaines & Internationales',
      appetizers: 'Entrées',
      mainCourses: 'Plats Principaux',
      desserts: 'Desserts',
      beverages: 'Boissons',
      specialMenus: 'Menus Spéciaux',
      commitments: 'Nos Engagements',
      nouvelAnTitle: 'Menu Nouvel An',
      nouvelAnDescription: 'Découvrez notre menu spécial pour les fêtes de fin d\'année',
      downloadMenu: 'Télécharger le Menu',
      freshIngredients: 'Ingrédients Frais',
      freshIngredientsDesc: 'Nous sélectionnons les meilleurs ingrédients locaux et de saison pour garantir la qualité de nos plats.',
      authenticRecipes: 'Recettes Authentiques',
      authenticRecipesDesc: 'Nos chefs perpétuent les traditions culinaires marocaines avec des recettes authentiques et savoureuses.',
      varietyRenewal: 'Variété & Renouvellement',
      varietyRenewalDesc: 'Notre buffet est régulièrement renouvelé pour vous offrir une expérience toujours nouvelle et variée.',
      dishesInImages: 'Nos Plats en Images',
      readyToDiscover: 'Prêt à Découvrir Nos Saveurs ?',
      readyToDiscoverDesc: 'Réservez votre table et profitez d\'un dîner dans une ambiance unique.',
      reserveNow: 'Réserver Maintenant',
      reserveTableDesc: 'Réservez votre table et profitez d\'un dîner dans une ambiance unique.',
      // Appetizers
      saladeMorocaine: 'Assortiment de salades marocaines',
      pastillaPoultry: 'Pastilla au poulet et amandes',
      pastillaMer: 'Pastilla de la mer',
      briouates: 'Assortiment de briouates',
      saladeBurrata: 'Salade burrata',
      nemsVegetariens: 'Assortiment de nems végétariens',
      // Main Courses
      tanjia: 'Tanjia',
      taginePoultry: 'Tagine de poulet au citron et olives',
      tagineBeef: 'Tagine de bœuf aux légumes',
      tagineBeefPrunes: 'Tagine de bœuf aux pruneaux et amandes',
      tagineVeal: 'Tagine d\'agneau aux légumes',
      tagineVealPrunes: 'Tagine d\'agneau aux pruneaux et amandes',
      tagineVegetarian: 'Tagine végétarien',
      couscousVegetarian: 'Couscous végétarien aux 7 légumes',
      couscousBeef: 'Couscous bœuf',
      couscousPoultry: 'Couscous poulet',
      couscousVeal: 'Couscous agneau',
      couscousMerguez: 'Couscous merguez',
      couscousRoyal: 'Couscous Royal',
      filetBeef: 'Filet de bœuf au poivre',
      paveSalmon: 'Pavé de saumon',
      // Desserts
      fondantChocolate: 'Fondant au chocolat et glace vanille',
      fruitSalad: 'Salade de fruits frais',
      frenchToast: 'Pain perdu et glace vanille',
      orangeSalad: 'Salade d\'orange à la canelle',
      // Special Menus
      menuDiscovery: 'Menu Découverte Jana',
      menuChild: 'Menu Enfant',
      appetizersChoice: 'Entrées au choix',
      firstCourseChoice: 'Premier plat au choix',
      secondCourseTable: 'Second plat servi pour l\'ensemble de la table',
      dessertChoice: 'Dessert au choix',
      dishChoice: 'Plat au choix',
      iceCreamBall: 'Boule de glace',
      steakFries: 'Steak haché pâtes ou frites',
    },
    // Gallery Page
    gallery: {
      title: 'Galerie Photos',
      subtitle: 'Découvrez l\'ambiance unique de Jana Marrakech',
      magicMoments: 'Nos Moments Magiques',
      magicMomentsDesc: 'Plongez dans l\'atmosphère festive et chaleureuse de notre restaurant à travers ces images',
      restaurant: 'Restaurant',
      dishes: 'Plats',
      ambiance: 'Ambiance',
      liveExperience: 'Vivez l\'Expérience Jana Marrakech',
      liveExperienceDesc: 'Rejoignez-nous pour créer vos propres souvenirs inoubliables',
      reserveNow: 'Réserver Maintenant',
    },
    // Contact Page
    contact: {
      title: 'Nous Contacter',
      sendMessage: 'Envoyez-nous un Message',
      fullName: 'Nom Complet',
      email: 'Email',
      phone: 'Téléphone',
      subject: 'Sujet',
      message: 'Message',
      sendButton: 'Envoyer le Message',
      confirmSend: 'Confirmer l\'envoi',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      successMessage: 'Merci! Votre message a été envoyé avec succès.',
      errorMessage: 'Une erreur s\'est produite. Veuillez réessayer.',
      validationErrors: 'Erreurs de validation:',
      nameRequired: 'Le nom est requis',
      emailRequired: 'L\'email est requis',
      emailInvalid: 'L\'email n\'est pas valide',
      phoneRequired: 'Le téléphone est requis',
      subjectRequired: 'Le sujet est requis',
      messageRequired: 'Le message est requis',
      findUs: 'Comment Nous Trouver',
      location: 'Zone Touristique De L, Bd Mohamed VI, Marrakech 40000',
      contactInfo: 'Informations de Contact',
      address: 'Adresse',
      hours: 'Horaires d\'Ouverture',
      mondayFriday: 'Du lundi au vendredi:',
      weekend: 'Weekend:',
      followUs: 'Suivez-nous',
      sendUsMessage: 'Envoyez-nous un Message',
      reserveOrAsk: 'Réservez votre table ou posez-nous vos questions',
    },
    // Reservation Page
    reservation: {
      title: 'Réservation',
      subtitle: 'Réservez votre table en ligne',
      bookTable: 'Réserver une Table',
      bookYourTable: 'Réservez Votre Table',
      bookYourTableDesc: 'Remplissez le formulaire ci-dessous pour réserver votre table',
      date: 'Date',
      time: 'Heure',
      guests: 'Nombre de Personnes',
      reserve: 'Réserver',
      phone: 'Téléphone',
      email: 'Email',
      hours: 'Horaires',
      hoursText: '18H - 01H00 | Weekend: 03H',
    },
    // Footer
    footer: {
      address: 'Adresse',
      phone: 'Téléphone',
      email: 'Email',
      hours: 'Horaires',
      followUs: 'Suivez-nous',
      allRightsReserved: 'Tous droits réservés',
      quickLinks: 'Liens Rapides',
      contact: 'Contact',
      description: 'Vivez une expérience culinaire unique à Marrakech, alliant gastronomie marocaine, spectacles authentiques et musique gnawa.',
      addressText: 'Zone Touristique De L, Bd Mohamed VI, Marrakech 40000',
      mondayFriday: 'Du lundi au vendredi:',
      weekend: 'Weekend',
      developedBy: 'Développé par',
      footerHome: 'Accueil',
      footerAbout: 'À Propos',
      footerMenu: 'Menu',
      footerGallery: 'Galerie',
      footerContact: 'Contact',
      footerReservation: 'Réservation',
    },
  },
  en: {
    // Navbar
    navbar: {
      home: 'Home',
      about: 'About',
      menu: 'Menu',
      gallery: 'Gallery',
      contact: 'Contact',
      reservation: 'booking',
      hoursTopBar: 'FROM 6:00 PM TO 1:00 AM | WEEKEND UNTIL 3:00 AM',
    },
    // Home Page
    home: {
      welcome: 'Welcome to Jana Marrakech',
      subtitle: 'MOROCCAN RESTAURANT',
      heroDescription: 'Nestled in the heart of the prestigious Complexe of Pacha in Marrakech',
      exploreMenu: 'Explore Menu',
      bookTable: 'Book Now',
      welcomeDesc1: 'Discover a unique culinary experience in Marrakech. Located in the heart of the prestigious Complexe of Pacha, Jana Marrakech offers an innovative concept that combines gastronomy, entertainment and Moroccan hospitality.',
      welcomeDesc2: 'Our choice menu offers a varied selection of authentic Moroccan dishes and international specialties.',
      learnMore: 'Learn More',
      specialties: 'Our Specialties',
      ambiance: 'Authentic Ambiance',
      service: 'Excellent Service',
      moroccanCuisine: 'Moroccan Cuisine',
      moroccanCuisineDesc: 'A varied selection of Moroccan dishes prepared with passion',
      showAmbiance: 'Show & Ambiance',
      danseusesGnawa: 'Dancers | Gnawa',
      showAmbianceDesc: 'Live shows and entertainment for an unforgettable evening in Marrakech',
      janaExperience: 'The JANA Experience',
      janaExperienceDesc: 'Enjoy a complete evening with Moroccan cuisine, drinks and shows included.',
      galleryPhotos: 'Photo Gallery',
      galleryPhotosDesc: 'Discover the unique atmosphere of Jana Marrakech',
      viewMorePhotos: 'View More Photos',
      hours: 'Hours',
      hoursOpen: 'From 6:00 PM to 1:00 AM',
      hoursWeekend: 'Weekend Until 3:00 AM',
      address: 'Address',
      addressText: 'Zone Touristique De L\nBd Mohamed VI, Marrakech 40000',
      reservation: 'Reservation',
      reserveNow: 'Book Now',
      reserveTable: 'Book your table',
      reserveTableDesc: 'Experience unique cuisine at the prestigious Pacha Complex in Marrakech',
    },
    // About Page
    about: {
      title: 'About Jana Marrakech',
      description: 'Discover our story and passion for Moroccan cuisine',
      ourStory: 'Our Story',
      ourMission: 'Our Mission',
      ourValues: 'Our Values',
      ourValuesDesc: 'The principles that guide our commitment to excellence',
      uniqueExperience: 'A unique culinary experience in Marrakech',
      storyPart1: 'Jana Marrakech was born from an audacious vision: to create a place where Moroccan gastronomy meets the legendary hospitality of our city.',
      storyPart2: 'Located in the prestigious Pacha Complex, in the heart of the Agdal tourist district, our restaurant offers a unique experience that combines a refined menu and live entertainment in an elegant and welcoming atmosphere.',
      storyPart3: 'Every evening, we welcome our guests in a festive and friendly atmosphere, where the authentic flavors of Morocco blend with international influences to create an unforgettable culinary experience.',
      concept: 'The JANA Concept',
      conceptDesc: 'A unique experience in Marrakech, nestled in the heart of the prestigious Pacha Complex.',
      moroccanCuisine: 'Moroccan Cuisine',
      moroccanCuisineDesc: 'Our menu is ideal for discovering or rediscovering traditional Moroccan flavors. Discover a selection of authentic dishes, prepared with fresh, quality ingredients. Our talented chefs offer a refined and delicious menu for an exceptional experience.',
      showAmbiance: 'Show & Ambiance',
      showAmbianceDesc: 'Experience an animated evening with our live shows and entertainment. Traditional Moroccan music, oriental dance and festive atmosphere are on the agenda to make your evening an unforgettable moment.',
      exceptionalSetting: 'Exceptional Setting',
      exceptionalSettingDesc: 'Our restaurant combines modern elegance with traditional Moroccan touches. Careful decor and warm atmosphere create the perfect setting for your evenings with friends or family.',
      excellence: 'Excellence',
      excellenceDesc: 'We are committed to providing exceptional quality in every aspect of your experience.',
      passion: 'Passion',
      passionDesc: 'Our passion for Moroccan gastronomy is reflected in every dish we serve.',
      hospitality: 'Hospitality',
      hospitalityDesc: 'Authentic Moroccan hospitality is at the heart of our service.',
      innovation: 'Innovation',
      innovationDesc: 'Moroccan restaurant and entertainment in a unique setting in Marrakech.',
      dedicatedTeam: 'A Passionate Team',
      dedicatedTeamDesc: 'Our team of talented chefs and dedicated professionals works every day to provide you with an exceptional experience. From the kitchen to the dining room, through the bar and shows, each member of our team contributes to creating the magic of Jana Marrakech.',
      tradition: 'We are proud to perpetuate the tradition of Moroccan hospitality while innovating to surprise you with every visit.',
      joinUs: 'Join us for an unforgettable evening',
      joinUsDesc: 'Discover why Jana Marrakech has become the must-visit destination for a unique experience',
    },
    // Menu Page
    menu: {
      title: 'Our Menu',
      subtitle: 'Moroccan & International Flavors',
      appetizers: 'Appetizers',
      mainCourses: 'Main Courses',
      desserts: 'Desserts',
      beverages: 'Beverages',
      specialMenus: 'Special Menus',
      commitments: 'Our Commitments',
      nouvelAnTitle: 'New Year Menu',
      nouvelAnDescription: 'Discover our special menu for the end-of-year celebrations',
      downloadMenu: 'Download Menu',
      freshIngredients: 'Fresh Ingredients',
      freshIngredientsDesc: 'We select the best local and seasonal ingredients to guarantee the quality of our dishes.',
      authenticRecipes: 'Authentic Recipes',
      authenticRecipesDesc: 'Our chefs perpetuate Moroccan culinary traditions with authentic and delicious recipes.',
      varietyRenewal: 'Variety & Renewal',
      varietyRenewalDesc: 'Our buffet is regularly renewed to offer you an always new and varied experience.',
      dishesInImages: 'Our Dishes in Images',
      readyToDiscover: 'Ready to Discover Our Flavors?',
      readyToDiscoverDesc: 'Book your table and enjoy dinner in a unique atmosphere.',
      reserveNow: 'Book Now',
      reserveTableDesc: 'Book your table and enjoy dinner in a unique atmosphere.',
      // Appetizers
      saladeMorocaine: 'Moroccan Salad Assortment',
      pastillaPoultry: 'Chicken Pastilla with Almonds',
      pastillaMer: 'Seafood Pastilla',
      briouates: 'Briouates Assortment',
      saladeBurrata: 'Burrata Salad',
      nemsVegetariens: 'Vegetarian Spring Rolls Assortment',
      // Main Courses
      tanjia: 'Tanjia',
      taginePoultry: 'Chicken Tagine with Lemon and Olives',
      tagineBeef: 'Beef Tagine with Vegetables',
      tagineBeefPrunes: 'Beef Tagine with Prunes and Almonds',
      tagineVeal: 'Lamb Tagine with Vegetables',
      tagineVealPrunes: 'Lamb Tagine with Prunes and Almonds',
      tagineVegetarian: 'Vegetarian Tagine',
      couscousVegetarian: 'Vegetarian Couscous with 7 Vegetables',
      couscousBeef: 'Beef Couscous',
      couscousPoultry: 'Chicken Couscous',
      couscousVeal: 'Lamb Couscous',
      couscousMerguez: 'Merguez Couscous',
      couscousRoyal: 'Royal Couscous',
      filetBeef: 'Beef Fillet with Pepper',
      paveSalmon: 'Salmon Fillet',
      // Desserts
      fondantChocolate: 'Chocolate Fondant with Vanilla Ice Cream',
      fruitSalad: 'Fresh Fruit Salad',
      frenchToast: 'French Toast with Vanilla Ice Cream',
      orangeSalad: 'Orange Salad with Cinnamon',
      // Special Menus
      menuDiscovery: 'Jana Discovery Menu',
      menuChild: 'Children\'s Menu',
      appetizersChoice: 'Appetizers of Your Choice',
      firstCourseChoice: 'First Course of Your Choice',
      secondCourseTable: 'Second Course Served for the Entire Table',
      dessertChoice: 'Dessert of Your Choice',
      dishChoice: 'Dish of Your Choice',
      iceCreamBall: 'Ice Cream Scoop',
      steakFries: 'Ground Beef with Pasta or Fries',
    },
    // Gallery Page
    gallery: {
      title: 'Photo Gallery',
      subtitle: 'Discover the unique atmosphere of Jana Marrakech',
      magicMoments: 'Our Magic Moments',
      magicMomentsDesc: 'Immerse yourself in the festive and warm atmosphere of our restaurant through these images',
      restaurant: 'Restaurant',
      dishes: 'Dishes',
      ambiance: 'Ambiance',
      liveExperience: 'Experience Jana Marrakech',
      liveExperienceDesc: 'Join us to create your own unforgettable memories',
      reserveNow: 'Book Now',
    },
    // Contact Page
    contact: {
      title: 'Contact Us',
      sendMessage: 'Send us a Message',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      sendButton: 'Send Message',
      confirmSend: 'Confirm Send',
      cancel: 'Cancel',
      confirm: 'Confirm',
      successMessage: 'Thank you! Your message has been sent successfully.',
      errorMessage: 'An error occurred. Please try again.',
      validationErrors: 'Validation Errors:',
      nameRequired: 'Name is required',
      emailRequired: 'Email is required',
      emailInvalid: 'Email is not valid',
      phoneRequired: 'Phone is required',
      subjectRequired: 'Subject is required',
      messageRequired: 'Message is required',
      findUs: 'How to Find Us',
      location: 'Zone Touristique De L, Bd Mohamed VI, Marrakech 40000',
      contactInfo: 'Contact Information',
      address: 'Address',
      hours: 'Opening Hours',
      mondayFriday: 'Monday to Friday:',
      weekend: 'Weekend:',
      followUs: 'Follow Us',
      sendUsMessage: 'Send us a Message',
      reserveOrAsk: 'Reserve your table or ask us your questions',
    },
    // Reservation Page
    reservation: {
      title: 'Reservation',
      subtitle: 'Reserve your table online',
      bookTable: 'Book a Table',
      bookYourTable: 'Book Your Table',
      bookYourTableDesc: 'Fill out the form below to reserve your table',
      date: 'Date',
      time: 'Time',
      guests: 'Number of Guests',
      reserve: 'Reserve',
      phone: 'Phone',
      email: 'Email',
      hours: 'Hours',
      hoursText: '6:00 PM - 1:00 AM | Weekend: 3:00 AM',
    },
    // Footer
    footer: {
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      hours: 'Hours',
      followUs: 'Follow Us',
      allRightsReserved: 'All rights reserved',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      description: 'Experience unique cuisine in Marrakech, combining Moroccan gastronomy, authentic shows and gnawa music.',
      addressText: 'Zone Touristique De L, Bd Mohamed VI, Marrakech 40000',
      mondayFriday: 'Monday to Friday:',
      weekend: 'Weekend',
      developedBy: 'Developed by',
      footerHome: 'Home',
      footerAbout: 'About',
      footerMenu: 'Menu',
      footerGallery: 'Gallery',
      footerContact: 'Contact',
      footerReservation: 'Reservation',
    },
  },
};

